import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebaseConfig';
import { useUser } from '../contexts/UserContext';
import { useMatch } from '../contexts/MatchContext';
import { useAdmin } from '../contexts/AdminContext';

import './Sidebar.css';

import homeIcon from '../assets/mobile-header.png';
import customIcon from '../assets/kategorien-icon.png';
import dailyIcon from '../assets/daily-icon.png';
import flagIcon from '../assets/flag-icon.png';
import countryIcon from '../assets/country-icon.png';
import profileIcon from '../assets/profile-icon.png';
import rankedIcon from '../assets/ranked-icon.png';
import articlesIcon from '../assets/articles-icon.png';
import leaderboardIcon from '../assets/leaderboard-icon.png';

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, userData } = useUser();
    const { match, matchReady, resetMatchState } = useMatch();
    const { isAdmin } = useAdmin();

    // Check if the current page is a match page
    const isOnMatchPage = location.pathname.startsWith('/match/');

    const handleLogout = async () => {
        try {
            // First reset match state
            if (resetMatchState) {
                resetMatchState();
            }

            // Then sign out
            await auth.signOut();

            // Navigate to the homepage after logout
            navigate('/');
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    // Check if the current user is anonymous (using Firebase Auth's built-in flag)
    const isAnonymous = user?.isAnonymous;

    return (
        <div className="sidebar">
            <Link className="sidebar-header-link" to="/">
                <img src={homeIcon} alt="Home" className="sidebar-head-img" />
            </Link>

            <Link className="sidebar-link" to="/daily">
                <img src={dailyIcon} alt="Daily Mode" className="sidebar-icon" />
                <span className="sidebar-text">Daily</span>
            </Link>

            <Link className="sidebar-link" to="/battle">
                <img src={rankedIcon} alt="Battle" className="sidebar-icon" />
                <span className="sidebar-text">Battle</span>
            </Link>

            <Link className="sidebar-link" to="/custom">
                <img src={customIcon} alt="Custom" className="sidebar-icon" />
                <span className="sidebar-text">Custom</span>
            </Link>

            <Link className="sidebar-link" to="/flag-quiz">
                <img src={flagIcon} alt="Flag Quiz" className="sidebar-icon" />
                <span className="sidebar-text">Flags</span>
            </Link>

            <Link className="sidebar-link" to="/country-quiz">
                <img src={countryIcon} alt="Country Quiz" className="sidebar-icon" />
                <span className="sidebar-text">Countries</span>
            </Link>

            <Link className="sidebar-link" to="/leaderboard">
                <img src={leaderboardIcon} alt="Flag Leaderboard" className="sidebar-icon" />
                <span className="sidebar-text">Leaderboard</span>
            </Link>

            <Link className="sidebar-link" to="/articles">
                <img src={articlesIcon} alt="Articles" className="sidebar-icon" />
                <span className="sidebar-text">Articles</span>
            </Link>

            {/* Show profile link only for non-anonymous users */}
            {user && !isAnonymous && (
                <Link className="sidebar-link" to={`/profile/${userData?.username}`}>
                    <img src={profileIcon} alt="Profile" className="sidebar-icon" />
                    <span className="sidebar-text">Profile</span>
                </Link>
            )}

            {/* Admin link - only shown for admin users */}
            {isAdmin && (
                <Link className="sidebar-link admin-link" to="/admin">
                    <span className="sidebar-text">Admin Panel</span>
                </Link>
            )}

            {/* Match button - only shown when user is in an active match AND not already on a match page */}
            {user && match && matchReady && !isOnMatchPage && (
                <button className="sidebar-match-button" onClick={() => navigate(`/match/${match.id}`)}>
                    Go to Match
                </button>
            )}

            {/* Show logout button only for non-anonymous users */}
            {user && !isAnonymous ? (
                <button className="logoutButton" onClick={handleLogout}>Log Out</button>
            ) : (
                // For anonymous users, show Sign Up and Log In buttons
                <>
                    <button className="registerButton" onClick={() => navigate("/register")}>Sign Up</button>
                    <button className="loginButton" onClick={() => navigate("/login")}>Log In</button>
                </>
            )}
        </div>
    );
};

export default Sidebar;
